import { render, staticRenderFns } from "./zszp.vue?vue&type=template&id=57a60aac&scoped=true&"
import script from "./zszp.vue?vue&type=script&lang=js&"
export * from "./zszp.vue?vue&type=script&lang=js&"
import style0 from "./zszp.vue?vue&type=style&index=0&id=57a60aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a60aac",
  null
  
)

export default component.exports